const languages = [
  { short: "en", long: "English", rtl: false },
  { short: "de", long: "Deutsch", rtl: false },
  { short: "nl", long: "Nederlands", rtl: false },
  { short: "es", long: "Español", rtl: false },
  { short: "fa", long: "فارسی", rtl: true },
  { short: "fr", long: "Français", rtl: false },
  { short: "sl", long: "Slovenščina", rtl: false },
  { short: "zh", long: "简体中文", rtl: false },
];

export default languages;
